import constants from '../constants.js';
import { stripInvalidCharacters } from '../helpers/stringHelpers.js';
import findIndex from 'lodash/findIndex';

export const types = {
  GET_PREFERENCES: 'CUSTOMER/GET_PREFERENCES',
  GET_PREFERENCES_SUCCESS: 'CUSTOMER/GET_PREFERENCES_SUCCESS',
  GET_PREFERENCES_ERROR: 'CUSTOMER/GET_PREFERENCES_ERROR',
  GET_TENANCY: 'CUSTOMER/GET_TENANCY',
  GET_TENANCY_SUCCESS: 'CUSTOMER/GET_TENANCY_SUCCESS',
  GET_TENANCY_ERROR: 'CUSTOMER/GET_TENANCY_ERROR',
  GET_ACCOUNT: 'CUSTOMER/GET_ACCOUNT',
  GET_ACCOUNT_SUCCESS: 'CUSTOMER/GET_ACCOUNT_SUCCESS',
  GET_ACCOUNT_ERROR: 'CUSTOMER/GET_ACCOUNT_ERROR',
  GET_LETTERS: 'CUSTOMER/GET_LETTERS',
  GET_LETTERS_SUCCESS: 'CUSTOMER/GET_LETTERS_SUCCESS',
  GET_LETTERS_ERROR: 'CUSTOMER/GET_LETTERS_ERROR',
  GET_TRANSACTIONS: 'CUSTOMER/GET_TRANSACTIONS',
  GET_TRANSACTIONS_SUCCESS: 'CUSTOMER/GET_TRANSACTIONS_SUCCESS',
  GET_TRANSACTIONS_ERROR: 'CUSTOMER/GET_TRANSACTIONS_ERROR',
  GET_WORK_REQUESTS: 'CUSTOMER/GET_WORK_REQUESTS',
  GET_WORK_REQUESTS_SUCCESS: 'CUSTOMER/GET_WORK_REQUESTS_SUCCESS',
  GET_WORK_REQUESTS_ERROR: 'CUSTOMER/GET_WORK_REQUESTS_ERROR',
  GET_APPOINTMENTS: 'CUSTOMER/GET_APPOINTMENTS',
  GET_APPOINTMENTS_SUCCESS: 'CUSTOMER/GET_APPOINTMENTS_SUCCESS',
  GET_APPOINTMENTS_ERROR: 'CUSTOMER/GET_APPOINTMENTS_ERROR',
  GET_CONTACT_DETAILS: 'CUSTOMER/GET_CONTACT_DETAILS',
  GET_CONTACT_DETAILS_SUCCESS: 'CUSTOMER/GET_CONTACT_DETAILS_SUCCESS',
  GET_CONTACT_DETAILS_ERROR: 'CUSTOMER/GET_CONTACT_DETAILS_ERROR',
  GET_BANK_DETAILS: 'CUSTOMER/GET_BANK_DETAILS',
  GET_BANK_DETAILS_SUCCESS: 'CUSTOMER/GET_BANK_DETAILS_SUCCESS',
  GET_BANK_DETAILS_ERROR: 'CUSTOMER/GET_BANK_DETAILS_ERROR',
  DELETE_CONTACT: 'CUSTOMER/DELETE_CONTACT',
  DELETE_CONTACT_SUCCESS: 'CUSTOMER/DELETE_CONTACT_SUCCESS',
  DELETE_CONTACT_ERROR: 'CUSTOMER/DELETE_CONTACT_ERROR',
  UPDATE_CONTACT: 'CUSTOMER/UPDATE_CONTACT',
  UPDATE_CONTACT_SUCCESS: 'CUSTOMER/UPDATE_CONTACT_SUCCESS',
  UPDATE_CONTACT_ERROR: 'CUSTOMER/UPDATE_CONTACT_ERROR',
  DELETE_BANK: 'CUSTOMER/DELETE_BANK',
  DELETE_BANK_SUCCESS: 'CUSTOMER/DELETE_BANK_SUCCESS',
  DELETE_BANK_ERROR: 'CUSTOMER/DELETE_BANK_ERROR',
  UPDATE_BANK: 'CUSTOMER/UPDATE_BANK',
  UPDATE_BANK_SUCCESS: 'CUSTOMER/UPDATE_BANK_SUCCESS',
  UPDATE_BANK_ERROR: 'CUSTOMER/UPDATE_BANK_ERROR',
  CREATE_BANK: 'CUSTOMER/CREATE_BANK',
  CREATE_BANK_SUCCESS: 'CUSTOMER/CREATE_BANK_SUCCESS',
  CREATE_BANK_ERROR: 'CUSTOMER/CREATE_BANK_ERROR',
  UNLOAD_BANK_DETAILS: 'CUSTOMER/UNLOAD_BANK_DETAILS',
  CREATE_PREFERENCES: 'CUSTOMER/CREATE_PREFERENCES',
  SET_SHOW_SURVEY: 'CUSTOMER/SET_SHOW_SURVEY',
  CREATE_CONSENTED_PERSON: 'CUSTOMER/CREATE_CONSENTED_PERSON',
  CREATE_CONSENTED_PERSON_SUCCESS: 'CUSTOMER/CREATE_CONSENTED_PERSON_SUCCESS',
  CREATE_CONSENTED_PERSON_ERROR: 'CUSTOMER/CREATE_CONSENTED_PERSON_ERROR',
  DELETE_CONSENTED_PERSON: 'CUSTOMER/DELETE_CONSENTED_PERSON',
  DELETE_CONSENTED_PERSON_SUCCESS: 'CUSTOMER/DELETE_CONSENTED_PERSON_SUCCESS',
  DELETE_CONSENTED_PERSON_ERROR: 'CUSTOMER/DELETE_CONSENTED_PERSON_ERROR',
  ADD_VIEWED_SURVEY: 'CUSTOMER/ADD_VIEWED_SURVEY',
  CREATE_ARRANGEMENT: 'CUSTOMER/CREATE_ARRANGEMENT',
  CREATE_ARRANGEMENT_SUCCESS: 'CUSTOMER/CREATE_ARRANGEMENT_SUCCESS',
  CREATE_ARRANGEMENT_ERROR: 'CUSTOMER/CREATE_ARRANGEMENT_ERROR',
  SET_RECEIVE_ALERTS: 'CUSTOMER/SET_RECEIVE_ALERTS',
  SET_VIEWED_LETTER: 'CUSTOMER/SET_VIEWED_LETTER',
};

const initialState = {
  preferences: {
    loaded: constants.UNLOADED,
    data: [],
    receiveAlerts: null,
    viewedLetters: [],
    newNotificationPreferences: [],
    submittedNotificationPreference: [],
  },
  tenancy: {
    loaded: constants.UNLOADED,
    data: {},
  },
  account: {
    loaded: constants.UNLOADED,
    data: {},
  },
  letters: {
    loaded: constants.UNLOADED,
    data: {},
  },
  transactions: {
    rent: {
      loaded: constants.UNLOADED,
      data: {},
    },
    maintenance: {
      loaded: constants.UNLOADED,
      data: {},
    },
  },
  workRequests: {
    open: {
      loaded: constants.UNLOADED,
      data: [],
    },
    completed: {
      loaded: constants.UNLOADED,
      data: [],
    },
    cancelled: {
      loaded: constants.UNLOADED,
      data: [],
    },
  },
  appointments: {
    loaded: constants.UNLOADED,
    data: {},
  },
  contactDetails: {
    loaded: constants.UNLOADED,
    data: {
      contactDetails: {
        preferredPhoneName: '',
        preferredPhone: '',
        mobilePhoneName: '',
        mobilePhone: '',
        email: '',
      },
      emergencyContacts: [
        {
          name: '',
          phone: '',
        },
        {
          name: '',
          phone: '',
        },
      ],
    },
  },
  bankDetails: {
    loaded: constants.UNLOADED,
    data: [],
  },
  viewedSurveys: [],
  newArrangementState: null,
  updateContact: null,
  updateContactId: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  let httpCode, loaded;

  switch (type) {
    case types.GET_PREFERENCES:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_PREFERENCES_SUCCESS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_PREFERENCES_ERROR:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.GET_TENANCY:
      return {
        ...state,
        tenancy: {
          ...state.tenancy,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_TENANCY_SUCCESS:
      return {
        ...state,
        tenancy: {
          ...state.tenancy,
          loaded:
            payload.status == 204
              ? constants.FAILED_NOT_FOUND
              : constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_TENANCY_ERROR:
      return {
        ...state,
        tenancy: {
          ...state.tenancy,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.GET_ACCOUNT:
      return {
        ...state,
        account: {
          ...state.account,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        account: {
          ...state.account,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_ACCOUNT_ERROR:
      return {
        ...state,
        account: {
          ...state.account,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.GET_LETTERS:
      return {
        ...state,
        letters: {
          ...state.letters,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_LETTERS_SUCCESS:
      return {
        ...state,
        letters: {
          ...state.letters,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_LETTERS_ERROR:
      return {
        ...state,
        letters: {
          ...state.letters,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.GET_TRANSACTIONS:
      return {
        ...state,
        transactions: {
          ...state.transactions,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        transactions: {
          rent: {
            ...state.transactions.rent,
          },
          maintenance: {
            ...state.transactions.maintenance,
          },
          [payload.accountType]: {
            loaded: constants.LOADED,
            data: payload.resp.data,
          },
        },
      };
    case types.GET_TRANSACTIONS_ERROR:
      return {
        ...state,
        transactions: {
          loaded: constants.FAILED_FATAL,
          rent: {
            ...state.transactions.rent,
          },
          maintenance: {
            ...state.transactions.maintenance,
          },
          [payload.accountType]: {
            loaded: constants.FAILED_FATAL,
            data: {},
          },
        },
      };
    case types.GET_WORK_REQUESTS:
      return {
        ...state,
        workRequests: {
          ...state.workRequests,
          [payload]: {
            loaded: constants.UNLOADED,
            data: [],
          },
        },
      };
    case types.GET_WORK_REQUESTS_SUCCESS:
      return {
        ...state,
        workRequests: {
          ...state.workRequests,
          [payload.status]: {
            loaded: constants.LOADED,
            data: payload.data ? payload.data : [],
          },
        },
      };
    case types.GET_WORK_REQUESTS_ERROR:
      return {
        ...state,
        workRequests: {
          ...state.workRequests,
          [payload.status]: {
            loaded: constants.FAILED_FATAL,
          },
        },
      };
    case types.CREATE_ARRANGEMENT: {
      return {
        ...state,
        createArrangement: {
          ...payload.data,
        },
        newArrangementState: constants.STATE_CREATING,
      };
    }
    case types.CREATE_ARRANGEMENT_SUCCESS: {
      return {
        ...state,
        newArrangementState: constants.STATE_SUCCESS,
      };
    }
    case types.CREATE_ARRANGEMENT_ERROR: {
      return {
        ...state,
        newArrangementState: constants.STATE_FAIL,
      };
    }
    case types.GET_APPOINTMENTS:
      return {
        ...state,
        appointments: {
          ...state.appointments,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_APPOINTMENTS_SUCCESS:
      return {
        ...state,
        appointments: {
          ...state.appointments,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_APPOINTMENTS_ERROR:
      return {
        ...state,
        appointments: {
          ...state.appointments,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.GET_CONTACT_DETAILS:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_CONTACT_DETAILS_SUCCESS:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_CONTACT_DETAILS_ERROR:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.GET_BANK_DETAILS:
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.UNLOADED,
        },
      };
    case types.GET_BANK_DETAILS_SUCCESS:
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.LOADED,
          data: payload.data,
        },
      };
    case types.GET_BANK_DETAILS_ERROR:
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.FAILED_FATAL,
        },
      };
    case types.DELETE_CONTACT:
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.UNLOADED,
        },
      };
    case types.DELETE_CONTACT_SUCCESS: {
      const index = findIndex(
        state.contactDetails.data.emergencyContacts,
        function (c) {
          return c.id == payload.data.subject;
        }
      );
      state.contactDetails.data.emergencyContacts.find(
        (c) => c.id === payload.data.subject
      );

      let emergencyContacts = [];
      const contactCount = state.contactDetails.data.emergencyContacts.length;

      if (contactCount > 1) {
        if (index === 0) {
          emergencyContacts = [
            {
              ...state.contactDetails.data.emergencyContacts[1],
            },
          ];
        } else {
          emergencyContacts = [
            {
              ...state.contactDetails.data.emergencyContacts[0],
            },
          ];
        }
      }

      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.LOADED,
          data: {
            ...state.contactDetails.data,
            emergencyContacts: [...emergencyContacts],
          },
        },
      };
    }
    case types.DELETE_CONTACT_ERROR:
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: loaded,
        },
      };
    case types.UPDATE_CONTACT:
      let contactData = payload.data;
      contactData.forEach((contact, key) => {
        if (contact) {
          if (contact.value) {
            contactData[key] = stripInvalidCharacters(contact, [
              'contactName',
              'value',
            ]);
          }
        }
      });
      return {
        ...state,
        updateContactId: payload.contactId,
        updateContact: {
          ...contactData,
        },
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.UNLOADED,
        },
      };
    case types.UPDATE_CONTACT_SUCCESS: {
      let contactData = payload.data.contact;

      // Find which contacts have been updated
      let phone = contactData.find(function (c) {
        return c.type == 'preferredPhone';
      });
      let mobile = contactData.find(function (c) {
        return c.type == 'mobilePhone';
      });
      let email = contactData.find(function (c) {
        return c.type == 'email';
      });
      let emergency = contactData.find(function (c) {
        return c.type == 'emergency';
      });

      // Get original contact data for each contact
      const oldMobilePhone =
        state.contactDetails.data.contactDetails.mobilePhone;
      const oldMobilePhoneName =
        state.contactDetails.data.contactDetails.mobilePhoneName;
      const oldPreferredPhone =
        state.contactDetails.data.contactDetails.preferredPhone;
      const oldPreferredPhoneName =
        state.contactDetails.data.contactDetails.preferredPhoneName;
      const oldEmail = state.contactDetails.data.contactDetails.email;

      // Get new contact values - use old value if no new contact value present
      const newMobilePhone = mobile ? mobile['value'] : oldMobilePhone;
      const newMobilePhoneName = mobile
        ? mobile['contactName']
        : oldMobilePhoneName;
      const newPreferredPhone = phone ? phone['value'] : oldPreferredPhone;
      const newPreferredPhoneName = phone
        ? phone['contactName']
        : oldPreferredPhoneName;
      const newEmail = email ? email['value'] : oldEmail;

      // Determine if contact data has changed
      let contactUpdating = false;
      if (
        newMobilePhone != oldMobilePhone ||
        newMobilePhoneName != oldMobilePhoneName ||
        newPreferredPhone != oldPreferredPhone ||
        newPreferredPhoneName != oldPreferredPhoneName ||
        newEmail != oldEmail
      ) {
        contactUpdating = true;
      }

      let emergencyContacts = [];

      if (emergency) {
        emergencyContacts.push({
          name: emergency.contactName,
          phone: emergency.value,
          id: emergency.id,
          updating: emergency.updating,
        });

        const otherEmergencyContact =
          state.contactDetails.data.emergencyContacts.find(
            (c) =>
              c.id != emergency.id ||
              (c.name != emergency.contactName &&
                c.phone != emergency.value &&
                c.id == '')
          );
        if (otherEmergencyContact) {
          emergencyContacts.push({
            name: otherEmergencyContact.name,
            phone: otherEmergencyContact.phone,
            id: otherEmergencyContact.id,
            updating: otherEmergencyContact.updating,
          });
        }
      } else {
        emergencyContacts = state.contactDetails.data.emergencyContacts;
      }

      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.LOADED,
          data: {
            ...state.contactDetails.data,
            contactDetails: {
              ...state.contactDetails.data.contactDetails,
              preferredPhoneName: newPreferredPhoneName,
              preferredPhone: newPreferredPhone,
              mobilePhoneName: newMobilePhoneName,
              mobilePhone: newMobilePhone,
              email: newEmail,
              updating: contactUpdating,
            },
            emergencyContacts: [...emergencyContacts],
          },
        },
      };
    }
    case types.UPDATE_CONTACT_ERROR:
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: loaded,
        },
      };
    case types.DELETE_BANK: {
      return {
        ...state,
        deleteAccountId: payload.accountId,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.UNLOADED,
        },
      };
    }
    case types.DELETE_BANK_SUCCESS: {
      const existingData = state.bankDetails.data.filter(
        (a) => a.accountId != state.deleteAccountId
      );

      // This is to keep track of whether the user has entered the same details twice
      localStorage.removeItem('bankAccountUpdatedTime');

      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.LOADED,
          data: [...existingData],
        },
      };
    }
    case types.DELETE_BANK_ERROR: {
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: loaded,
        },
      };
    }
    case types.UPDATE_BANK: {
      return {
        ...state,
        updateAccountId: payload.accountId,
        updateBankAccount: {
          ...payload.data,
        },
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.UNLOADED,
        },
      };
    }
    case types.UPDATE_BANK_SUCCESS: {
      const bankAccount = payload.data.bankAccount;

      const existingData = state.bankDetails.data.filter(
        (a) => a.accountId != state.updateAccountId
      );

      // This is to keep track of whether the user has entered the same details twice
      const updateTime = Math.floor(Date.now() / 1000);
      localStorage.setItem('bankAccountUpdatedTime', updateTime);

      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.LOADED,
          refreshRequired: true,
          data: [
            ...existingData,
            {
              accountId: bankAccount.accountId,
              accountName: bankAccount.accountName,
              accountNumber: bankAccount.accountNumber,
              bankName: bankAccount.bankName,
              bankReference: bankAccount.bankReference,
              createdDate: bankAccount.createdDate,
            },
          ],
        },
      };
    }
    case types.UPDATE_BANK_ERROR: {
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: loaded,
        },
      };
    }
    case types.CREATE_BANK: {
      return {
        ...state,
        createBankAccount: {
          ...payload.data,
        },
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.UNLOADED,
        },
      };
    }
    case types.CREATE_BANK_SUCCESS: {
      const bankAccount = payload.data.bankAccount;

      const existingData = state.bankDetails.data;

      // This is to keep track of whether the user has entered the same details twice
      const updateTime = Math.floor(Date.now() / 1000);
      localStorage.setItem('bankAccountUpdatedTime', updateTime);

      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.LOADED,
          refreshRequired: true,
          data: [
            ...existingData,
            {
              accountId: bankAccount.accountId,
              accountName: bankAccount.accountName,
              accountNumber: bankAccount.accountNumber,
              bankName: bankAccount.bankName,
              bankReference: bankAccount.bankReference,
              createdDate: bankAccount.createdDate,
            },
          ],
        },
      };
    }
    case types.CREATE_BANK_ERROR: {
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: loaded,
        },
      };
    }
    case types.UNLOAD_BANK_DETAILS:
      return {
        ...state,
        bankDetails: {
          ...state.bankDetails,
          loaded: constants.UNLOADED,
        },
      };
    case types.CREATE_CONSENTED_PERSON: {
      let consentedPersonData = payload.data;
      consentedPersonData = stripInvalidCharacters(consentedPersonData, [
        'details',
      ]);

      return {
        ...state,
        createConsentedPerson: {
          ...payload.data,
        },
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.UNLOADED,
        },
      };
    }
    case types.CREATE_CONSENTED_PERSON_SUCCESS: {
      const consentedPerson = {
        ...payload.data.consentedPerson,
        updating: true,
      };

      const existingData = state.contactDetails.data.consentedPersons || [];

      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.LOADED,
          data: {
            ...state.contactDetails.data,
            consentedPersons: [consentedPerson, ...existingData],
          },
        },
      };
    }
    case types.CREATE_CONSENTED_PERSON_ERROR: {
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: loaded,
        },
      };
    }
    case types.DELETE_CONSENTED_PERSON:
      return {
        ...state,
        deleteConsentedPersonId: payload.consentedPersonId,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.UNLOADED,
        },
      };
    case types.DELETE_CONSENTED_PERSON_SUCCESS: {
      const consentedPersons =
        state.contactDetails.data.consentedPersons.filter(
          (c) => c.id != payload.data.subject
        );

      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: constants.LOADED,
          data: {
            ...state.contactDetails.data,
            consentedPersons: [...consentedPersons],
          },
        },
      };
    }
    case types.DELETE_CONSENTED_PERSON_ERROR:
      loaded = constants.FAILED;
      if (payload.response) {
        httpCode = payload.response.status;
        if (httpCode != 500 && httpCode != 503 && httpCode != 504) {
          loaded = constants.FAILED_FATAL;
        }
      }
      if (payload.fatal) {
        loaded = constants.FAILED_FATAL;
      }
      return {
        ...state,
        contactDetails: {
          ...state.contactDetails,
          loaded: loaded,
        },
      };
    case types.ADD_VIEWED_SURVEY:
      const viewedSurveys = [...state.viewedSurveys];
      viewedSurveys.push(payload);
    case types.CREATE_PREFERENCES:
      // Notification preferences require special handling, as we do not want
      // to unload and reload (via API) the existing preference data.
      if (payload.notificationPreference) {
        const submittedPreference = payload.data.preferences[0];
        const newNotificationPreferences = [];

        // Keep record of newly created notification preferences in the session.
        // The submitted notification preference should override any in the
        // session of the same type.
        state.preferences.newNotificationPreferences.forEach((element) => {
          if (submittedPreference.key != element.key) {
            newNotificationPreferences.push(element);
          }
        });

        newNotificationPreferences.push(submittedPreference);

        return {
          ...state,
          preferences: {
            ...state.preferences,
            // All notification preferences stored in the session.
            newNotificationPreferences: newNotificationPreferences,
            // The new notification preference to be submitted
            submittedNotificationPreference: [...payload.data.preferences],
          },
        };
      } else {
        return {
          ...state,
          preferences: {
            ...state.preferences,
            loaded: constants.UNLOADED,
            data: payload.data,
          },
        };
      }
    case types.SET_SHOW_SURVEY:
      return {
        ...state,
        viewedSurveys: viewedSurveys,
      };
    case types.SET_RECEIVE_ALERTS:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          receiveAlerts: payload,
        },
      };
    case types.SET_VIEWED_LETTER:
      const newViewedLetters = [...state.preferences.viewedLetters];
      newViewedLetters.push(payload);

      return {
        ...state,
        preferences: {
          ...state.preferences,
          viewedLetters: newViewedLetters,
        },
      };
  }

  return state;
}

export const actions = {
  getPreferences: () => ({
    type: types.GET_PREFERENCES,
  }),
  createPreferences: (data, notificationPreference = false) => ({
    type: types.CREATE_PREFERENCES,
    payload: { data, notificationPreference },
  }),
  getTenancy: () => ({
    type: types.GET_TENANCY,
  }),
  getAccount: () => ({
    type: types.GET_ACCOUNT,
  }),
  getLetters: () => ({
    type: types.GET_LETTERS,
  }),
  getTransactions: () => ({
    type: types.GET_TRANSACTIONS,
  }),
  getWorkRequests: (status = 'open') => ({
    type: types.GET_WORK_REQUESTS,
    payload: status,
  }),
  createArrangement: (data) => ({
    type: types.CREATE_ARRANGEMENT,
    payload: { data },
  }),
  getAppointments: () => ({
    type: types.GET_APPOINTMENTS,
  }),
  getContactDetails: () => ({
    type: types.GET_CONTACT_DETAILS,
  }),
  getBankDetails: () => ({
    type: types.GET_BANK_DETAILS,
  }),
  deleteContact: (contactId) => ({
    type: types.DELETE_CONTACT,
    payload: contactId,
  }),
  updateContact: (contactId, data) => ({
    type: types.UPDATE_CONTACT,
    payload: { contactId, data },
  }),
  updateBankAccount: (accountId, data) => ({
    type: types.UPDATE_BANK,
    payload: { accountId, data },
  }),
  deleteBankAccount: (accountId) => ({
    type: types.DELETE_BANK,
    payload: { accountId },
  }),
  createBankAccount: (data) => ({
    type: types.CREATE_BANK,
    payload: { data },
  }),
  unloadBankDetails: () => ({
    type: types.UNLOAD_BANK_DETAILS,
  }),
  addViewedSurvey: (surveyId) => ({
    type: types.ADD_VIEWED_SURVEY,
    payload: surveyId,
  }),
  setReceiveAlerts: (value) => ({
    type: types.SET_RECEIVE_ALERTS,
    payload: value,
  }),
  setViewedLetter: (letterId) => ({
    type: types.SET_VIEWED_LETTER,
    payload: letterId,
  }),
  deleteConsentedPerson: (consentedPersonId) => ({
    type: types.DELETE_CONSENTED_PERSON,
    payload: { consentedPersonId },
  }),
  createConsentedPerson: (data) => ({
    type: types.CREATE_CONSENTED_PERSON,
    payload: { data },
  }),
};
